<template>
  <div class="meetingList">
    <h1>首页</h1>
  </div>
</template>

<script>
export default {
  name: 'Home',
  props: {
    msg: String
  }
}
</script>


<style scoped lang="scss">
  $title-color:red;
  .meetingList{
    color:$title-color
  }
</style>
